import CityPageTemplate from "../city-template/CityPageTemplate";
import { highlandsRanchConfig } from "./data";

export default function HighlandsRanchPage() {
  return <CityPageTemplate config={highlandsRanchConfig} />;
}